import {
    CTAButton1,
    SecondaryButton
} from '../../_shared/buttons';
import FormInputTextWithLabelSpecial from './FormInputTextWithLabelSpecial';
import classes from './index.module.scss';
import { getPasswordResetUrl } from '../../../settings';

export const openInNewTab = () => {
    const url = getPasswordResetUrl();
    window.open(url, '_blank', 'noreferrer');
};

const forgotPasswordDiv = {
    display: 'inline-block',
    width: '100%'
};
const title = {
    display: 'inline-block',
    fontSize: '12px',
    fontWeight: 400,
    margin: '0px 2px 0px 0px'
};
const button = {
    display: 'inline-block',
    fontSize: '12px',
    fontWeight: 800,
    cursor: 'pointer',
    border: '2px solid #fff',
    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none',
    color: '#fff',
    lineHeight: '1.25rem',
    padding: '0.2em',
    background: 'none'
};

type LoginInputsProps = {
    inputsRef: React.MutableRefObject<HTMLDivElement | null>;
    setStage: (stage: string) => void;
    error: boolean;
    email: string;
    setEmail: (email: string) => void;
    password: string;
    setPassword: (password: string) => void;
    loading: boolean;
    stage: string;
};

export const LoginInputs = ({
    inputsRef,
    setStage,
    error,
    email,
    setEmail,
    password,
    setPassword,
    loading,
    stage
}: LoginInputsProps) => (
    <div className={classes.formInputsDiv} ref={inputsRef}>
        <div>
            <div id="login-error-message" role="alert" aria-live="polite">
                {!!error && 'Incorrect username or password'}
            </div>
            <div>
                <FormInputTextWithLabelSpecial
                    autoComplete="email"
                    error={!!error}
                    label="email"
                    type="email"
                    id="email"
                    required
                    value={email}
                    aria-label="Enter your email"
                    aria-required="true"
                    aria-invalid={!!error}
                    aria-describedby={error ? 'login-error-message' : undefined}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div>
                <FormInputTextWithLabelSpecial
                    autoComplete="current-password"
                    error={!!error}
                    label="password"
                    type="password"
                    id="password"
                    required
                    value={password}
                    aria-label="Enter your password"
                    aria-required="true"
                    aria-invalid={!!error}
                    aria-describedby={error ? 'login-error-message' : undefined}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
        </div>
        <div style={forgotPasswordDiv}>
            <h5 style={title}>Forgot your password?</h5>
            <button
                style={button}
                aria-label="Get a password reset link"
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openInNewTab();
                }}
            >
                Get a reset link
            </button>
        </div>
        <div
            style={{
                textAlign: 'center',
                marginTop: 40
            }}
        >
            <CTAButton1
                invert
                type="submit"
                aria-label={loading ? 'Signing in' : 'Sign in'}
                style={{
                    paddingBlock: '0.6em',
                    outline: 'none'
                }}
            >
                {loading ? 'signing in' : 'sign in'}
            </CTAButton1>
            <div
                style={{
                    marginTop: 5,
                    paddingBottom: stage === 'signUp' ? 40 : 0
                }}
            >
                <div style={{ marginTop: '5px' }}>
                    or{' '}
                    <SecondaryButton
                        style={{ fontWeight: 800 }}
                        light
                        aria-label="Create an account"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setStage('signUp');
                        }}
                    >
                        Create an account
                    </SecondaryButton>
                </div>
            </div>
        </div>
    </div>
);
